import { ExtraParameterSection } from "widgets/modals/qr-codes/ExtraParameterSection";
import React from "react";

export const ExtraParametersRows = (props) => {
	return (props.fields.map((extraParamName, idx) => {
		return (
			<ExtraParameterSection
				key={extraParamName}
				name={extraParamName}
				removeExtraParam={() => {props.fields.remove(idx);}}
				extraParameterIndex = {idx}
				readOnly={props.disabled}
			/>
		);
	}));
};

ExtraParametersRows.displayName = "ExtraParametersRows";
